import React from "react";
import * as Styled from "./EmptySearchContainer.styles";
import { ASSETS } from "../../../../utils/config";

function EmptySearchContainer() {
  return (
    <Styled.Container>
      <Styled.ContainerChild>
        <Styled.ImageContainer>
          <img
            src={ASSETS.segmentEditor.SearchIcon}
            alt="This is search icon"
            width={"34.63px"}
            height={"34.63px"}
          />
        </Styled.ImageContainer>
        <Styled.TextContainer>
          <Styled.TextParagraph>
            No results found for your search. <br />
            Please try different keywords.
          </Styled.TextParagraph>
        </Styled.TextContainer>
      </Styled.ContainerChild>
    </Styled.Container>
  );
}

export default EmptySearchContainer;
